import React from 'react';
import PropTypes from 'prop-types';

import {Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from 'views/components';
import {Translate} from 'views/module';

import SyncCsvRow from './SyncCsvRow';

import Backend from 'utils/backend';

const CaregiverPaymentSyncCsvData = ({statusProgressWrap}) => {
  const [list, setList] = React.useState([]);

  React.useEffect(() => {
    statusProgressWrap(async () => {
      const result = await Backend.paymentSlip.listCaregiverPaymentSyncCsv();
      // Newest week first -- the backend returns them sorted ascending by start date.
      setList([...result.list].reverse());
    }, {showProgress: false, debugString: 'CaregiverPaymentSyncCsvData'});
  }, [statusProgressWrap]);

  if (list.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" align="center" sx={{mt: 2}}>
        <Translate expression='dashboardWidgets.CaregiverPaymentSyncCsv.Empty' />
      </Typography>
    );
  }

  return (
    <Box sx={{width: '100%'}}>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><Translate expression='dashboardWidgets.CaregiverPaymentSyncCsv.Week' /></TableCell>
              <TableCell><Translate expression='dashboardWidgets.CaregiverPaymentSyncCsv.File' /></TableCell>
              <TableCell align="right"><Translate expression='dashboardWidgets.CaregiverPaymentSyncCsv.Actions' /></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              list.map((item) => (
                <SyncCsvRow
                  key={item.weekOf}
                  item={item}
                  statusProgressWrap={statusProgressWrap}
                />
              ))
            }
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

CaregiverPaymentSyncCsvData.propTypes = {
  statusProgressWrap: PropTypes.func.isRequired,
};

export default React.memo(CaregiverPaymentSyncCsvData);
